import { useEffect, useState } from "react";
import { isValidSession } from "user-management/src/cognito/kahunUserAuth";
import { UserManagementPopupMode } from "../../../context/diagnosticAgent";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";
import { useHistory } from "react-router-dom";

export const useUserState = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  const { loginPopupState } = useDiagnosticNavigation();

  const history = useHistory();

  useEffect(() => {
    if (
      loginPopupState === UserManagementPopupMode.Closed ||
      loginPopupState === UserManagementPopupMode.Logout
    ) {
      (async () => {
        const isValid = await isValidSession();
        setIsUserLoggedIn(isValid);
      })();
    }
  }, [loginPopupState, history.location.search]);

  return { isUserLoggedIn };
};
